<template>
  <div class="left-energy">
    <div class="energy all">
      <home-part title="数据总览" :ETitle="'data screening'">
        <template #icon>
          <IconSet name="bar" />
        </template>
        <template v-slot:content>
          <SkeletonLoader v-if="loading" mode="card" />
          <div v-else class="energy-grid">
            <div class="energy-item">
              <div class="item-label">
                <IconSet class="item-icon" name="meter" />
                <span class="item-label-text">计量点个数</span>
              </div>
              <div class="item-value">
                <span class="item-num">{{ energy.monitorCount }}</span>
                <span class="item-unit">个</span>
              </div>
            </div>
            <div class="energy-item">
              <div class="item-label">
                <IconSet class="item-icon" name="today-energy" />
                <span class="item-label-text">今日总用电</span>
              </div>
              <div class="item-value">
                <span class="item-num" :style="{ fontSize: energy.todayEnergy.fontSize }">{{ energy.todayEnergy.text }}</span>
                <span class="item-unit">kwh</span>
              </div>
            </div>
            <div class="energy-item">
              <div class="item-label">
                <IconSet class="item-icon" name="month-energy" />
                <span class="item-label-text">上月总用电</span>
              </div>
              <div class="item-value">
                <span class="item-num" :style="{ fontSize: energy.oneBeforeMonthEnergy.fontSize }">{{ energy.oneBeforeMonthEnergy.text }}</span>
                <span class="item-unit">kwh</span>
              </div>
            </div>
            <div class="energy-item">
              <div class="item-label">
                <IconSet class="item-icon" name="carbon-leaf" />
                <span class="item-label-text">上月碳排放</span>
              </div>
              <div class="item-value">
                <span class="item-num" :style="{ fontSize: energy.oneBeforeMonthCarbon.fontSize }">{{ energy.oneBeforeMonthCarbon.text }}</span>
                <span class="item-unit">kg</span>
              </div>
            </div>
          </div>
        </template>
      </home-part>
    </div>
    <div class="energy last">
      <home-part title="上月耗电top10" :ETitle="'electricity consumption'">
        <template #icon>
          <IconSet name="lightning" />
        </template>
         <template v-slot:content>
           <SkeletonLoader v-if="loading" mode="list" />
           <div v-else class="top10-list">
             <div class="top10-row" v-for="(item , index) in lastMonthData" :key="index">
               <div class="row-inner">
                 <div class="row-left">
                   <IndexBadge>{{ index + 1 }}</IndexBadge>
                   <div class="row-name">{{ item.deptName }}</div>
                 </div>
                 <div class="row-right">
                   <span class="row-num">{{ numFmt(item.deptEnergy) }}</span>
                   <span class="row-unit">kwh</span>
                 </div>
               </div>
               <div class="top10-bar">
                 <div class="bar-fill" :style="'width:' + item.proportion + '%'">
                   <div class="bar-dot"></div>
                 </div>
               </div>
             </div>
           </div>
         </template>
      </home-part>
    </div>
  </div>
</template>

<script>
import HomePart from "@/components/h5/homePart.vue";
import IndexBadge from "@/components/h5/IndexBadge.vue";
import IconSet from "@/components/h5/IconSet.vue";
import SkeletonLoader from "@/components/h5/SkeletonLoader.vue"
import { numFmt, largeNumSize } from "@/utils/fmt";

export default {
  components:{
    HomePart,
    IndexBadge,
    IconSet,
    SkeletonLoader,
  },
  methods: {
    numFmt,
  },
  props:{
    lastMonthData:{
      type:Array,
      default: () => []
    },
    allEnergyData:{
      type: Object,
      default: () => {}
    },
    loading: {
      type: Boolean,
      default: false
    },
  },
  data(){
    return{}
  },
  computed: {
    energy() {
      const {
        monitorCount = 0,
        todayEnergy = 0,
        oneBeforeMonthEnergy = 0,
        oneBeforeMonthCarbon = 0
      } = this.allEnergyData || {}

      const fmt = v => {
        const text = numFmt(v)
        return { text, fontSize: largeNumSize(text) }
      }

      return {
        monitorCount,
        todayEnergy: fmt(todayEnergy),
        oneBeforeMonthEnergy: fmt(oneBeforeMonthEnergy),
        oneBeforeMonthCarbon: fmt(oneBeforeMonthCarbon)
      }
    }
  },
}
</script>

<style scoped lang="less">
.left-energy{
  flex: 1;
  min-height: 0;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.energy{
  padding: 0;
}

.all{
  height: 40%;
  width: 100%;
  min-width: 0;
  min-height: 0;
}

/* ponytail: data-overview grid replaces the old 2×2 energy-box layout */
.energy-grid {
  flex: 1;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 8px;
  padding-top: 8px;
}

.energy-grid .energy-item {
  background: rgba(42, 98, 255, 0.04);
  border: 1px solid rgba(42, 98, 255, 0.06);
  border-radius: 8px;
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  gap: 4px;
  transition: border-color 0.25s, background 0.25s;
}

.energy-grid .energy-item:hover {
  border-color: rgba(42, 98, 255, 0.2);
  background: rgba(42, 98, 255, 0.07);
}

.item-label {
  display: flex;
  align-items: center;
  gap: 6px;
}

.item-icon {
  flex-shrink: 0;
  display: block;
}

.item-label-text {
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 12px;
  color: rgba(108, 128, 151, 1);
  line-height: 1;
}

.item-value {
  display: flex;
  align-items: baseline;
  gap: 4px;
  padding-left: 26px;
  min-width: 0;           /* ponytail: allow truncation when number overflows */
}

.energy-grid .item-num {
  padding-left: 0;
  font-size: 22px;
  color: rgba(255, 255, 255, 0.95);
  font-family: "FROSTBITE-Narrow", sans-serif;
  letter-spacing: 0.5px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;            /* ponytail: shrink below content width so ellipsis kicks in */
}

.item-unit {
  flex-shrink: 0;          /* ponytail: always visible, never wraps */
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 11px;
  color: rgba(108, 128, 151, 0.8);
}

.last{
  height: 60%;
  width: 100%;
  min-width: 0;
  min-height: 0;
}

.top10-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
  padding-top: 6px;
  height: 100%;
  overflow: auto;
}

.top10-row {
  display: flex;
  flex-direction: column;
  padding: 3px 0 1px;
  gap: 2px;
}

.row-inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.row-left {
  display: flex;
  align-items: center;
  gap: 6px;
  min-width: 0;
  flex: 1;
}

.row-name {
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 12px;
  color: rgba(208, 222, 238, 0.9);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  min-width: 0;
}

.row-right {
  display: flex;
  align-items: baseline;
  gap: 3px;
  flex-shrink: 0;
  margin-left: 8px;
}

.row-num {
  font-family: "FROSTBITE-Narrow", sans-serif;
  font-size: 15px;
  color: #fff;
  letter-spacing: 0.3px;
}

.row-unit {
  font-family: "AlibabaPuHuiTi-2-55-Regular", sans-serif;
  font-size: 10px;
  color: rgba(108, 128, 151, 0.7);
}

.top10-bar {
  width: 100%;
  height: 3px;
  background: rgba(42, 98, 255, 0.06);
  border-radius: 2px;
  overflow: hidden;
}

.bar-fill {
  height: 100%;
  background: linear-gradient(90deg, #2A62FF 0%, rgba(42, 98, 255, 0.3) 100%);
  border-radius: 2px;
  position: relative;
  transition: width 0.4s ease;
}

.bar-dot {
  position: absolute;
  right: -4px;
  top: -3px;
  width: 9px;
  height: 9px;
  border-radius: 50%;
  background: #2A62FF;
  box-shadow: 0 0 6px rgba(42, 98, 255, 0.6);
}
</style>
